import { Icon } from '@iconify/react';
import classNames from 'classnames';
import Image from 'next/image';
import type { ComponentProps, FC } from 'react';

type Props = {
  placeholderIconProps?: Omit<ComponentProps<typeof Icon>, 'icon'>;
  imageContainerClassName?: string;
  src?: string | null;
  width: number | null;
  height: number | null;
};

const CompanyImage: FC<Props> = ({
  imageContainerClassName,
  placeholderIconProps,
  src,
  height,
  width,
}) => {
  if (!src)
    return (
      <Icon
        {...placeholderIconProps}
        icon="material-symbols-light:apartment"
        className="shrink-0"
      />
    );
  return (
    <div
      className={classNames(
        'h-10 w-10 shrink-0 flex items-center justify-center',
        imageContainerClassName
      )}
    >
      <Image
        src={src}
        alt=""
        width={width!}
        height={height!}
        className="rounded-lg object-contain"
      />
    </div>
  );
};

export default CompanyImage;
